"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*!
  Copyright (c) 2019 DynAgility LLC. All rights reserved.
  Licensed under the MIT License.
*/
exports.FETCH_URL_START = 'FETCH_URL_START';
exports.FETCH_URL_SUCCESS = 'FETCH_URL_SUCCESS';
exports.FETCH_URL_FAILED = 'FETCH_URL_FAILED';
exports.FETCH_URL_RESET = 'FETCH_URL_RESET';
exports.FAIL_AUTH = 'FAIL_AUTH';
exports.SUCCESS_AUTH = 'SUCCESS_AUTH';
exports.GET_METHOD = 'GET';
exports.POST_METHOD = 'POST';
exports.PUT_METHOD = 'PUT';
exports.DELETE_METHOD = 'DELETE';
